import { createSagaActionTypes } from '../../../utils/actionFactory';

export const UPDATE_DATALIMIT = 'UPDATE_DATALIMIT';
export const OPEN_DATALIMIT = 'OPEN_DATALIMIT';

export const actions = createSagaActionTypes('EDIT_DATALIMIT', [
  OPEN_DATALIMIT,
  UPDATE_DATALIMIT
]);
